import React, { useState, useEffect } from "react";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import banner from "../assets/imagen.jpg";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import "../components/cumplimientos.css";
import SocialBar from "../components/SocialBar";
import { Link } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";

import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';

const API_URL = "https://facach.coop.hn/api";

const FALLBACK = [
  { id: 1, titulo: "Programa de Cumplimiento", subtitulo: "Adaptado a su Cooperativa", descripcion: "Asesoría experta en la elaboración y actualización del Programa de Cumplimiento LA/FT.", accent_color: "#3B6FC4", bg_light: "#EAF1FF" },
  { id: 2, titulo: "Capacitación Especializada", subtitulo: "Para Cooperativas", descripcion: "Capacitaciones para las áreas de Auditoría Interna y Junta de Vigilancia.", accent_color: "#2E8B57", bg_light: "#EAF9F0" },
  { id: 3, titulo: "Planes de Acción Estratégicos", subtitulo: "Para Cooperativas", descripcion: "Asesoría en el desarrollo de Planes de Acción para la subsanación de hallazgos.", accent_color: "#B8860B", bg_light: "#FFF7E6" },
  { id: 4, titulo: "Planes Operativos Anuales (POA)", subtitulo: "Para funcionarios de Cumplimiento", descripcion: "Elaboración de Planes Operativos Anuales para el Funcionario de Cumplimiento.", accent_color: "#C94E64", bg_light: "#FFECEF" },
  { id: 5, titulo: "Plan Anual de Capacitación", subtitulo: "En LA/FT", descripcion: "Asesoría para la creación de un Plan Anual de Capacitación en Prevención de Lavado de Activos.", accent_color: "#6B4FC4", bg_light: "#F0EAFF" },
  { id: 6, titulo: "Sistema de Gestión SGCR-LAFT", subtitulo: "Para Cooperativas", descripcion: "Capacitación especializada de conformidad con los Estándares Internacionales.", accent_color: "#1A7B8C", bg_light: "#E6F7F9" },
];

function ProductoCard({ producto, index }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div className="cp-card" style={{
      "--accent": producto.accent_color || "#3B6FC4",
      "--bg-light": producto.bg_light || "#EAF1FF",
      animationDelay: `${index * 0.08}s`,
    }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className="cp-card-number">{String(index + 1).padStart(2, '0')}</span>
      <div className="cp-card-accent" />
      <div className="cp-card-icon-wrap"><FiCheckCircle size={30} /></div>
      <div className="cp-card-content">
        <p className="cp-card-subtitulo">{producto.subtitulo}</p>
        <h3 className="cp-card-titulo">{producto.titulo}</h3>
        <p className="cp-card-desc">{producto.descripcion}</p>
      </div>
      <div className="cp-card-arrow">→</div>
    </div>
  );
}

const Cumplimientos = () => {
  
const { settings } = useSiteSettings();
    const bannerSrc = settings.banner_image
      ? `https://facach.coop.hn${settings.banner_image}`
      : fallbackBanner;
  const [productos, setProductos] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res = await fetch(`${API_URL}/compliance-services`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok && json.data?.length > 0) setProductos(json.data);
      } catch (err) {
        console.error("Error cargando servicios de cumplimiento:", err.message);
      } finally { setLoading(false); }
    };
    fetch_();
  }, []);

  return (
    <div className="cumplimientos-page">
      <NavbarFacach />
      <div className="banner-wrapper">
        <Image src={bannerSrc} alt="Cumplimientos - FACACH" fluid className="banner-image" />
        <div className="banner-overlay">
          <h1 className="banner-title">CUMPLIMIENTO</h1>
        </div>
      </div>

      <Container className="cp-section">
        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <h2 className="at-section-title">Nuestros Servicios</h2>
            <p className="at-section-subtitle">
              El cumplimiento normativo es una prioridad fundamental. Enmarcados en las
              disposiciones de la Ley Especial Contra el Delito de Lavado de Activos, nos
              dedicamos a fortalecer el sector cooperativo a través de actividades de apoyo
              en capacitación y asesoría técnica. Nuestra labor prioriza la Socialización e
              Implementación de la "Normativa para Prevención, Detección, Control y
              Reporte de Lavado de Activos y el Financiamiento del Terrorismo (LA/FT) en
              el Sector Cooperativo"
            </p>
          </Col>
        </Row>

        {loading ? (
          <div className="text-center py-5" style={{ fontSize: 14, color: "#7a8aaa" }}>Cargando…</div>
        ) : (
          <div className="cp-grid">
            {productos.map((p, i) => <ProductoCard key={p.id} producto={p} index={i} />)}
          </div>
        )}

        <div className="cp-cta-wrap">
          <Button variant="primary" as={Link} to="/contacto_cumplimiento" className="cp-cta-btn">
            Contáctanos para obtener más información
          </Button>
        </div>
        <div className="boton-centro my-3">
          <Button as="a" href="/documentos/catalogo.pdf" target="_blank" rel="noopener noreferrer"
            variant="link" className="producto-vermas-link mt-auto p-0"
            style={{ color: "#252A58", textAlign: "center", opacity: "0.90" }}>
            Haz clic para ver nuestro Catálogo 
          </Button>
        </div>
      </Container>

      <SocialBar position="right" top="35%" size={42} rounded={true} />
      <FooterFacach />
    </div>
  );
};

export default Cumplimientos;